export default __webpack_public_path__ + "static/media/caLogo.42307f13.png";